
import { defineComponent } from "vue"
import dataset from "./ds.json"
import TableComp from '../components/TableComp.vue'
import GraphComp from '../components/GraphComp.vue'


export default defineComponent ({
  name: 'HomePage',
  props: {},
  components: {
      TableComp,
      GraphComp
   },
  data(){
    return {
      dataset:dataset,
      data:{},
      table_data_child:{},
      source_from_table:String,
      target_from_table:String,
      source:String,
      target:String      
    }
  },
  methods: {
    getdata(table_data_child: any,source_from_table: any,target_from_table: any){
      this.data = table_data_child
      this.source = source_from_table
      this.target = target_from_table
      console.log(this.data)
    },
    res(){
          var handler = document.querySelector('.handler') as HTMLElement;
          var wrapper = handler.closest('.wrapper') as HTMLElement;
          var boxA = wrapper.querySelector('.box') as HTMLElement;
          var isHandlerDragging = false;

          document.addEventListener('mousedown', function(e) {
            console.log(e)
            if (e.target === handler) {
              isHandlerDragging = true;
            }
          });

          document.addEventListener('mousemove', function(e) {
            if (!isHandlerDragging) {
              return false;
            }
            var containerOffsetLeft = wrapper.offsetLeft;
            var pointerRelativeXpos = e.clientX - containerOffsetLeft;
            var boxAminWidth = 60;
            boxA.style.width = (Math.max(boxAminWidth, pointerRelativeXpos - 8)) + 'px';
            boxA.style.flexGrow = "0";
          });

          document.addEventListener('mouseup', function(e) {
            isHandlerDragging = false;
          });
    }
  }
})
